import { render, staticRenderFns } from "./SafetyIslandDialog.vue?vue&type=template&id=38a3c4bd&scoped=true"
import script from "./SafetyIslandDialog.vue?vue&type=script&lang=js"
export * from "./SafetyIslandDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3c4bd",
  null
  
)

export default component.exports